import { gql } from "@apollo/client";
import {OrderType} from "../types/OrderType";

export const MARK_AS_EXCEPTION = gql`
    mutation OrderMutation($orderId: Long!, 
                           $exceptionReasonCode: String!, 
                           $exceptionImageS3KeysJson: [String!],
                           $exceptionHubId: Long!,
                           $exceptionWarehouseId: Long,
                           $exceptionSubReasons: [String!]) {
        markAsException(orderId: $orderId, 
                        exceptionReasonCode: $exceptionReasonCode, 
                        exceptionImageS3KeysJson: $exceptionImageS3KeysJson,
                        exceptionHubId: $exceptionHubId,
                        exceptionWarehouseId: $exceptionWarehouseId,
                        exceptionSubReasons: $exceptionSubReasons) {
            id
            securityRnd
            trackingNumber
            channelId
            channelOrderNumber
            orderTime
            overallStatus
            isDelivered
            isIntercepted
            isAbnormal
            expectedDeliveryTime
            deliveredAt
            deliveryAttempts
            exceptionReasonCode
            senderAddressId
            recipientAddressId
            receiverZipcode
            sortingCode
            weightKg
            volumetricWeightKg
            lengthCm
            widthCm
            heightCm
            packageValueUsd
            podReviewStatus
            podImageS3KeysJson
            exceptionImageS3KeysJson
            isDestHubArrived
            isDestWarehouseArrived
            destHubArrivedAt
            destWarehouseArrivedAt
            receivedAtHub
            deliverAt
            isComplaint
            hasManded
            isFinished
            createdAt
            updatedAt
        }
    }
`;

export interface MarkAsExceptionInput {
    orderId: string;
    exceptionReasonCode: string;
    exceptionImageS3KeysJson: string[];
    exceptionHubId: number;
    exceptionWarehouseId?: number;
    exceptionSubReasons?: string[] | null;
}

export interface MarkAsExceptionResponse {
    markAsException: OrderType;
}
